export default {
    init() {
        this.settingsAddNamesForm();
    },

    settingsAddNamesForm(){
        $(document).on('click', '.settings-form-add-names--isset-list .item span', function (e) {
            $(this).parent().remove();
        });

        $(document).on('submit', '.settings-form-add-names  ', function (e) {
            e.preventDefault();
            let value = $('.settings-form-add-names .form-input').val();
            $('.settings-form-add-names--isset-list').append('<div class="item">'+value+' <span data-anything=""></span></div>');
            $('.settings-form-add-names .form-input').val('');
        });
    },

}